/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ExperimentsOverlayRegressionRouteImport } from './routes/experiments.overlay-regression'
import { Route as ExperimentsCanvasTourRouteImport } from './routes/experiments.canvas-tour'
import { Route as AuthSignupRouteImport } from './routes/_auth/signup'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AuthSignupSsoCallbackRouteImport } from './routes/_auth/signup.sso-callback'
import { Route as AuthLoginSsoCallbackRouteImport } from './routes/_auth/login.sso-callback'
import { Route as AppCanvasIdRouteImport } from './routes/_app/canvas.$id'
import { Route as AppCanvasIdPrototypePrototypeIdRouteImport } from './routes/_app/canvas.$id.prototype.$prototypeId'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExperimentsOverlayRegressionRoute =
  ExperimentsOverlayRegressionRouteImport.update({
    id: '/experiments/overlay-regression',
    path: '/experiments/overlay-regression',
    getParentRoute: () => rootRouteImport,
  } as any)
const ExperimentsCanvasTourRoute = ExperimentsCanvasTourRouteImport.update({
  id: '/experiments/canvas-tour',
  path: '/experiments/canvas-tour',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AuthSignupSsoCallbackRoute = AuthSignupSsoCallbackRouteImport.update({
  id: '/sso-callback',
  path: '/sso-callback',
  getParentRoute: () => AuthSignupRoute,
} as any)
const AuthLoginSsoCallbackRoute = AuthLoginSsoCallbackRouteImport.update({
  id: '/sso-callback',
  path: '/sso-callback',
  getParentRoute: () => AuthLoginRoute,
} as any)
const AppCanvasIdRoute = AppCanvasIdRouteImport.update({
  id: '/canvas/$id',
  path: '/canvas/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCanvasIdPrototypePrototypeIdRoute =
  AppCanvasIdPrototypePrototypeIdRouteImport.update({
    id: '/prototype/$prototypeId',
    path: '/prototype/$prototypeId',
    getParentRoute: () => AppCanvasIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof AppDashboardRoute
  '/login': typeof AuthLoginRouteWithChildren
  '/signup': typeof AuthSignupRouteWithChildren
  '/experiments/canvas-tour': typeof ExperimentsCanvasTourRoute
  '/experiments/overlay-regression': typeof ExperimentsOverlayRegressionRoute
  '/canvas/$id': typeof AppCanvasIdRouteWithChildren
  '/login/sso-callback': typeof AuthLoginSsoCallbackRoute
  '/signup/sso-callback': typeof AuthSignupSsoCallbackRoute
  '/canvas/$id/prototype/$prototypeId': typeof AppCanvasIdPrototypePrototypeIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof AppDashboardRoute
  '/login': typeof AuthLoginRouteWithChildren
  '/signup': typeof AuthSignupRouteWithChildren
  '/experiments/canvas-tour': typeof ExperimentsCanvasTourRoute
  '/experiments/overlay-regression': typeof ExperimentsOverlayRegressionRoute
  '/canvas/$id': typeof AppCanvasIdRouteWithChildren
  '/login/sso-callback': typeof AuthLoginSsoCallbackRoute
  '/signup/sso-callback': typeof AuthSignupSsoCallbackRoute
  '/canvas/$id/prototype/$prototypeId': typeof AppCanvasIdPrototypePrototypeIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_app/dashboard': typeof AppDashboardRoute
  '/_auth/login': typeof AuthLoginRouteWithChildren
  '/_auth/signup': typeof AuthSignupRouteWithChildren
  '/experiments/canvas-tour': typeof ExperimentsCanvasTourRoute
  '/experiments/overlay-regression': typeof ExperimentsOverlayRegressionRoute
  '/_app/canvas/$id': typeof AppCanvasIdRouteWithChildren
  '/_auth/login/sso-callback': typeof AuthLoginSsoCallbackRoute
  '/_auth/signup/sso-callback': typeof AuthSignupSsoCallbackRoute
  '/_app/canvas/$id/prototype/$prototypeId': typeof AppCanvasIdPrototypePrototypeIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/login'
    | '/signup'
    | '/experiments/canvas-tour'
    | '/experiments/overlay-regression'
    | '/canvas/$id'
    | '/login/sso-callback'
    | '/signup/sso-callback'
    | '/canvas/$id/prototype/$prototypeId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/login'
    | '/signup'
    | '/experiments/canvas-tour'
    | '/experiments/overlay-regression'
    | '/canvas/$id'
    | '/login/sso-callback'
    | '/signup/sso-callback'
    | '/canvas/$id/prototype/$prototypeId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/_app/dashboard'
    | '/_auth/login'
    | '/_auth/signup'
    | '/experiments/canvas-tour'
    | '/experiments/overlay-regression'
    | '/_app/canvas/$id'
    | '/_auth/login/sso-callback'
    | '/_auth/signup/sso-callback'
    | '/_app/canvas/$id/prototype/$prototypeId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  ExperimentsCanvasTourRoute: typeof ExperimentsCanvasTourRoute
  ExperimentsOverlayRegressionRoute: typeof ExperimentsOverlayRegressionRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experiments/overlay-regression': {
      id: '/experiments/overlay-regression'
      path: '/experiments/overlay-regression'
      fullPath: '/experiments/overlay-regression'
      preLoaderRoute: typeof ExperimentsOverlayRegressionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experiments/canvas-tour': {
      id: '/experiments/canvas-tour'
      path: '/experiments/canvas-tour'
      fullPath: '/experiments/canvas-tour'
      preLoaderRoute: typeof ExperimentsCanvasTourRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/signup/sso-callback': {
      id: '/_auth/signup/sso-callback'
      path: '/sso-callback'
      fullPath: '/signup/sso-callback'
      preLoaderRoute: typeof AuthSignupSsoCallbackRouteImport
      parentRoute: typeof AuthSignupRoute
    }
    '/_auth/login/sso-callback': {
      id: '/_auth/login/sso-callback'
      path: '/sso-callback'
      fullPath: '/login/sso-callback'
      preLoaderRoute: typeof AuthLoginSsoCallbackRouteImport
      parentRoute: typeof AuthLoginRoute
    }
    '/_app/canvas/$id': {
      id: '/_app/canvas/$id'
      path: '/canvas/$id'
      fullPath: '/canvas/$id'
      preLoaderRoute: typeof AppCanvasIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/canvas/$id/prototype/$prototypeId': {
      id: '/_app/canvas/$id/prototype/$prototypeId'
      path: '/prototype/$prototypeId'
      fullPath: '/canvas/$id/prototype/$prototypeId'
      preLoaderRoute: typeof AppCanvasIdPrototypePrototypeIdRouteImport
      parentRoute: typeof AppCanvasIdRoute
    }
  }
}

interface AppCanvasIdRouteChildren {
  AppCanvasIdPrototypePrototypeIdRoute: typeof AppCanvasIdPrototypePrototypeIdRoute
}

const AppCanvasIdRouteChildren: AppCanvasIdRouteChildren = {
  AppCanvasIdPrototypePrototypeIdRoute: AppCanvasIdPrototypePrototypeIdRoute,
}

const AppCanvasIdRouteWithChildren = AppCanvasIdRoute._addFileChildren(
  AppCanvasIdRouteChildren,
)

interface AppRouteChildren {
  AppDashboardRoute: typeof AppDashboardRoute
  AppCanvasIdRoute: typeof AppCanvasIdRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppDashboardRoute: AppDashboardRoute,
  AppCanvasIdRoute: AppCanvasIdRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthLoginRouteChildren {
  AuthLoginSsoCallbackRoute: typeof AuthLoginSsoCallbackRoute
}

const AuthLoginRouteChildren: AuthLoginRouteChildren = {
  AuthLoginSsoCallbackRoute: AuthLoginSsoCallbackRoute,
}

const AuthLoginRouteWithChildren = AuthLoginRoute._addFileChildren(
  AuthLoginRouteChildren,
)

interface AuthSignupRouteChildren {
  AuthSignupSsoCallbackRoute: typeof AuthSignupSsoCallbackRoute
}

const AuthSignupRouteChildren: AuthSignupRouteChildren = {
  AuthSignupSsoCallbackRoute: AuthSignupSsoCallbackRoute,
}

const AuthSignupRouteWithChildren = AuthSignupRoute._addFileChildren(
  AuthSignupRouteChildren,
)

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRouteWithChildren
  AuthSignupRoute: typeof AuthSignupRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRouteWithChildren,
  AuthSignupRoute: AuthSignupRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  ExperimentsCanvasTourRoute: ExperimentsCanvasTourRoute,
  ExperimentsOverlayRegressionRoute: ExperimentsOverlayRegressionRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
